import React from 'react';
import { Rating } from 'semantic-ui-react';
import ReviewModal from './Meetings/ReviewModal';
import CustomLink from './CustomLink';
import Security from '../utils/Security';

const Review = ({ job }) => {
  if (job.overall_status === 'Scheduled') return null;

  const hasReviewed = !!job.ratingOnExpert || !!job.reviewOnExpert;
  const isProjectOwner = Security.isProjectOwner(job.project);
  const isCompleted = ['Completed', 'Paid'].includes(job.overall_status);

  return (
    <div>
      <Rating
        icon="star"
        rating={job.ratingOnExpert || 0}
        maxRating={5}
        disabled
      />
      {isProjectOwner && isCompleted && (
        <>
          <br />
          <ReviewModal meeting={job}>
            <CustomLink>
              {hasReviewed ? 'Edit Review' : 'Leave a Review'}
            </CustomLink>
          </ReviewModal>
        </>
      )}
    </div>
  );
};

export default Review;
